import { BaseModel } from './base-model';
import { ModelConfig } from './model-config';

export class User extends BaseModel{

  static create(attribs: Object) {
    return new User(attribs);
  }

  constructor(loadAttribs?: object) {

      // define permitted attributes.
      let config = new ModelConfig();
      config.permittedAttribs = [

          // profile attribs.
          "id", "name", "email", "password",

          // acl
          "roles"
      ];

      // instantiate BaseModel.
      super(config);

      // load any passed in attribs.
      if(typeof loadAttribs === "object" && Object.keys(loadAttribs).length)
      {
        super.load(loadAttribs);
      }
  }
}



// WEBPACK FOOTER //
// ./src/models/user.ts